import React from 'react';
import ProductSoloScreen from '../screens/ProductSoloScreen';

export default function ProductScanPage(): React.JSX.Element {
  return <ProductSoloScreen mode="page" />;}
